module.exports = __webpack_public_path__ + "static/media/workbg-bigpicture.5c7036b9.jpg";